<template>
  <div class="snaliens landing-page"> 
    <div class="artwork">
      <div class="title"/>
      <heads />
      <tree class="tree t1"/>
      <tree class="tree t2"/>
    </div>
    <div class="bottom"/>
  </div>
</template>

<script>
import Tree from '@/components/snaliens/objects/Tree.vue'
import Heads from '@/components/snaliens/objects/Heads.vue'
export default {
  components:
  {
    Tree,
    Heads,
  }

}
</script>

<style scoped>

.snaliens
{
  position: relative;
  background: url('https://i.imgur.com/Nz1ZECn.png');
  background-attachment: fixed;
}

.snaliens::before
{
  content: '';
  position: absolute;
  background: linear-gradient(0deg, #B3E5EE -20%, #5992B3DD 20%, #0891F600 100%);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.artwork
{
  position: relative;
  margin:auto;
  height: 100vh;
  width: 50vw;
}

@media screen and (min-width:1400px){
  .artwork{
    width: 50vw;
  }
}

@media screen and (max-width:1400px){
  .artwork{
    width: 100vw;
  }
}

.title
{
  position: absolute;
  background: url(https://i.imgur.com/xiyuPuc.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 50%;
}


.tree.t1
{
  position: absolute;
  right: -10%;
  bottom: 0;
  transform-origin: bottom;
  rotate: 5deg;
  scale: 0.8;
}
.tree.t2
{
  position: absolute;
  left: -10%;
  bottom: 0;
  transform-origin: bottom;
  rotate: -5deg;
  animation-delay: -1s;
}

.bottom
{
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 90px;
  clip-path:ellipse(70% 50% at 50% 100%); 
  background-color: #1F3764;
}


</style>